module.exports = "<div id=\"pmViewHolder\">\n\n  <app-pm-template2></app-pm-template2>\n  \n</div>  \n\n"